import { Box, Typography } from "@mui/material";
import { DailyHoursMap, computeUtilizationColor, formatHoursLabel, getDayHours } from "./hoursMetrics";

type CalendarDayHeaderProps = {
    date: Date;
    label: string;
    hoursMap: DailyHoursMap;
    showMetric: boolean;
};

export const CalendarDayHeader = ({ date, label, hoursMap, showMetric }: CalendarDayHeaderProps) => {
    const hours = getDayHours(hoursMap, date);
    const hoursLabel = formatHoursLabel(hours);
    const utilizationColor = computeUtilizationColor(hours);

    return (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", lineHeight: 1.2 }}>
            <span>{label}</span>
            {showMetric ? (
                <Typography variant="caption" sx={{ color: utilizationColor, fontWeight: 500, fontSize: "10px" }}>
                    {hoursLabel}
                </Typography>
            ) : null}
        </Box>
    );
};
